import * as React from 'react';

import {Modal} from '../modal/modal';

import {IframeComponent} from './iframe-component';

type Props = {
    url: string;
    title: string;
    onClose: () => void;
};

export function IframeModal(props: Props) {
    return (
        <Modal isOpen={true} onClose={props.onClose}>
            <IframeComponent src={props.url} title={props.title} />
        </Modal>
    );
}
